import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import(
        './components/app-store-publishing/app-store-publishing.component'
      ).then(m => m.AppStorePublishingComponent),
  },
];
